import { render, staticRenderFns } from "./ListFiltersBasic.vue?vue&type=template&id=bd6f7616&"
import script from "./ListFiltersBasic.vue?vue&type=script&lang=js&"
export * from "./ListFiltersBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports